import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const routes = [
  {
    name: 'diagnosis',
    path: '/diagnosis',
    component: r => require(['components/diagnosis/diagnosis.vue'], r),
    title: '大数据诊股'
  }, {
    path: '/diagnosis/:symbol',
    name: 'diagnosis-result',
    title: '诊股结果',
    component: r => require(['components/diagnosis/result/result.vue'], r)
  },
  {
    path: '/forbidden',
    name: 'forbidden',
    title: '无权限访问',
    component: r => require(['components/forbidden.vue'], r)
  }
]

export default new Router({
  routes
})



// WEBPACK FOOTER //
// ./src/router/index.js